import { mergeLeft, omit } from 'ramda'
import { useState } from 'react'

type DispatchValues<T> = (newValues: Partial<T>) => void
type RemoveValues<T> = (...keys: (keyof T)[]) => void

export const useStateObject = <T extends Record<string, any>>(
  initialValue: T,
): [
  T,
  DispatchValues<T>,
  RemoveValues<T>,
  React.Dispatch<React.SetStateAction<T>>,
] => {
  const [values, setValues] = useState<T>(initialValue || {})

  const dispatchValues: DispatchValues<T> = (newValues) => {
    setValues(
      (prevValues) => (mergeLeft(newValues, prevValues) as unknown) as T,
    )
  }

  const removeValues: RemoveValues<T> = (...keys) => {
    setValues((prevValues) => omit(keys, prevValues) as T)
  }

  return [values, dispatchValues, removeValues, setValues]
}
